import _export from '../internals/export.js';
import freezing from '../internals/freezing.js';
import fails$1 from '../internals/fails.js';
import isObject$1 from '../internals/is-object.js';
import '../internals/internal-metadata.js';
import { i as internalMetadata } from '../../../../../../_virtual/internal-metadata.js';

var $ = _export;
var FREEZING = freezing;
var fails = fails$1;
var isObject = isObject$1;
var onFreeze = internalMetadata.exports.onFreeze; // eslint-disable-next-line es/no-object-freeze -- safe

var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () {
  $freeze(1);
}); // `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze

$({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES,
  sham: !FREEZING
}, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});
